// extracted by mini-css-extract-plugin
module.exports = {"right":"FormVerticalButton_right__2ATiE"};